import VirtualAppointmentEducationSwiper from './VirtualAppointmentEducationSwiper';
import modalManager from '../../../../../modules/modalManager';
/**
 * Open the virtual appointment modal
 */
export const openModal = () => modalManager.openModal(VirtualAppointmentEducationSwiper);

export default VirtualAppointmentEducationSwiper;
